import { createFeature, createReducer, on } from '@ngrx/store';

import * as actions from './shared-auth-call.actions';

export interface State {
  error: boolean;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  error: false,
  loaded: false,
  loading: false,
};

export default createFeature({
  name: 'sharedAuthCall',
  reducer: createReducer(
  initialState,
  on(actions.error, (state: State): State => ({
    ...state,
    loading: false,
    error: true,
  })),
  on(actions.load, (state: State): State => ({
    ...state,
    loading: true,
  })),
  on(actions.received, (state: State): State => ({
    ...state,
    loaded: true,
    loading: false,
  })),
  on(actions.reset, (_state: State): State => ({
    ...initialState,
  })),
  )}
);